import React from "react";
import { FormattedMessage } from "react-intl";
import { useOfferActions } from "src/offers/hooks/useOffers";
import type Offer from "src/offers/objects/Offer";
import {
  type IRaangeLabelProps,
  type IRaangeLabelWithFAProps,
  RaangeLabel,
} from "src/shared/components/RaangeLabel";
import { BooleanStatusFormatter } from "src/shared/formatters/BooleanStatusFormatter";
import { Formatter } from "src/shared/formatters/Formatter";

export const OfferLabel = (props: IRaangeLabelWithFAProps) => {
  return (
    <RaangeLabel fa="offer-alt" {...props}>
      <FormattedMessage id="offers" />
    </RaangeLabel>
  );
};

export const OfferCreate = (props: IRaangeLabelWithFAProps) => {
  return (
    <RaangeLabel fa="plus" {...props}>
      <FormattedMessage id="offers.create" />
    </RaangeLabel>
  );
};

export const OfferEdit = (props: IRaangeLabelWithFAProps) => {
  return (
    <RaangeLabel fa="pencil-alt" {...props}>
      <FormattedMessage id="offers.edit" />
    </RaangeLabel>
  );
};

export interface IOfferFormatterProps extends Omit<IRaangeLabelProps, "fa"> {
  children: Offer;
}

export const OfferStatus = (props: IOfferFormatterProps) => {
  return (
    <BooleanStatusFormatter>
      {props.children.offerStatus}
    </BooleanStatusFormatter>
  );
};

export interface IOfferTypeProps extends IOfferFormatterProps {
  countryCode: string;
}
export const OfferType = ({
  countryCode,
  children: offer,
}: IOfferTypeProps) => {
  const { data: offerActionsMap } = useOfferActions(countryCode);
  return <Formatter>{offerActionsMap?.get(offer.action)?.name}</Formatter>;
};
